var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKitchen = function SvgKitchen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kitchen_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    d: "M.006 24h9.886v-5.67H.006zm2.162-4.201h5.608v1.406H2.168zM.006 16.925h9.886V11.35H.006zm2.162-4.08h5.608v1.406H2.168z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.297 24h12.697V11.35H11.297zm8.434-11.155h1.405v1.44h-1.405zm-2.811 0h1.405v1.44H16.92zm-2.812 0h1.406v1.44h-1.406zm0 2.698h7.028v5.646h-7.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M19.73 3.24V0h-4.216v3.243l-4.217 2.811v2.485h12.697V6.052z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kitchen_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgKitchen;